import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Resource {
    id: number;
    name: string;
    title?: string;
    // Add other fields as needed
}

interface CourseResourcesState {
    data: Resource[] | null;
    isLoading: boolean;
    error: any;
}

const initialState: CourseResourcesState = {
    data: null,
    isLoading: false,
    error: null,
};

const courseResourcesSlice = createSlice({
    name: "CourseResourcesSlice",
    initialState,
    reducers: {
        fetchResources: (state, action: PayloadAction<{ subject_id: string | number; resource_type: string }>) => {
            state.isLoading = true;
            state.error = null;
        },
        successCourseResources: (state, action: PayloadAction<Resource[]>) => {
            state.isLoading = false;
            state.data = action.payload;
            state.error = null;
        },
        failureCourseResources: (state, action: PayloadAction<any>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        resetCourseResources: (state) => {
            state.data = null;
            state.isLoading = false;
            state.error = null;
        }
    },
});

export const { fetchResources, successCourseResources, failureCourseResources, resetCourseResources } = courseResourcesSlice.actions;
export default courseResourcesSlice.reducer;
